<template>
  <div class="step2-option-card" @click="$emit('select')" :class="!isCredit ? 'step2-option-card--sm' : ''">

    <!-- Топ только для кредита -->
    <p v-if="isCredit && showIndex" class="step2-option-card__index">
      ТОП-{{ showIndex }} по одобрениям
    </p>

    <!-- Картинка -->
    <img
      :src="resolvedImage"
      alt=""
      class="step2-option-card__logo"
      :class="isCredit ? 'step2-option-card__logo--is-credit' : ''"
    />

    <!-- Описание для кредита -->
    <div
      v-if="isCredit && description"
      class="step2-option-card__description"
      v-html="description"
    >
    </div>

    <!-- Title для рассрочки -->
    <h3
      v-if="!isCredit"
      class="step2-option-card__title"
      :class="isCredit ? 'step2-option-card__title--is-credit' : ''"
      v-html="title"
    ></h3>

    <!--  Tooltip  -->
    <div
      v-if="!isCredit && tooltipContent"
      class="switch-tooltip-wrapper"
    >
      <a-tooltip
        placement="top"
        :autoAdjustOverflow="true"
        overlayClassName="custom-ant-tooltip"
      >
        <template #title>
          <div class="tooltip-content">
            <p class="tooltip-first">
              {{ tooltipContent.text1 }}
            </p>

            <p class="tooltip-second">
              {{ tooltipContent.text2 }}
            </p>
          </div>
        </template>

        <div class="switch-tooltip-icon">
          <!-- твой SVG -->
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M9 15H11V9H9V15ZM10 7C10.2833 7 10.521 6.904 10.713 6.712C10.905 6.52 11.0007 6.28267 11 6C10.9993 5.71733 10.9033 5.48 10.712 5.288C10.5207 5.096 10.2833 5 10 5C9.71667 5 9.47933 5.096 9.288 5.288C9.09667 5.48 9.00067 5.71733 9 6C8.99933 6.28267 9.09533 6.52033 9.288 6.713C9.48067 6.90567 9.718 7.00133 10 7ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88334 18.6867 3.825 17.9743 2.925 17.075C2.025 16.1757 1.31267 15.1173 0.788001 13.9C0.263335 12.6827 0.000667933 11.3827 1.26582e-06 10C-0.000665401 8.61733 0.262001 7.31733 0.788001 6.1C1.314 4.88267 2.02633 3.82433 2.925 2.925C3.82367 2.02567 4.882 1.31333 6.1 0.788C7.318 0.262667 8.618 0 10 0C11.382 0 12.682 0.262667 13.9 0.788C15.118 1.31333 16.1763 2.02567 17.075 2.925C17.9737 3.82433 18.6863 4.88267 19.213 6.1C19.7397 7.31733 20.002 8.61733 20 10C19.998 11.3827 19.7353 12.6827 19.212 13.9C18.6887 15.1173 17.9763 16.1757 17.075 17.075C16.1737 17.9743 15.1153 18.687 13.9 19.213C12.6847 19.739 11.3847 20.0013 10 20Z" fill="#A9A9A9" />
          </svg>
        </div>
      </a-tooltip>
    </div>

  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import installmentWithoutFirst from '@/assets/img/installment-without-first.svg'
import installmentWithFirst from '@/assets/img/installment-with-first.svg'

const props = defineProps<{
  title?: string
  description?: string
  providerImage?: string   // логотип банка
  isCredit?: boolean
  showIndex?: number
  withFirstPayment?: boolean
}>()

const resolvedImage = computed(() => {
  if (props.providerImage) return props.providerImage

  return props.withFirstPayment
    ? installmentWithFirst
    : installmentWithoutFirst
})

const tooltipContent = computed(() => {
  if (props.isCredit) return null

  // BNPL (без первого взноса)
  if (!props.withFirstPayment) {
    return {
      text1: 'Подходит, если вы не хотите переплачивать проценты и готовы пройти стандартную проверку банка.',
      text2: 'Вы сможете выбрать банк и условия на следующих шагах'
    }
  }

  // Обычная рассрочка (с первым взносом)
  return {
    text1: 'Подходит, если вам важно быстрее получить одобрение и снизить риск отказа.',
    text2: 'Вы сможете выбрать банк и условия на следующих шагах'
  }
})
</script>

<style scoped lang="scss">
.step2-option-card {
  border: 2px solid transparent;
  border-radius: 20px;
  padding: 20px;
  position: relative;

  background: #f7f9fa;
  cursor: pointer;
  transition: 0.25s ease;
  display: flex;
  align-items: center;
  gap: 20px;

  &--sm {
    @include mobile {
      width: calc(100% - 32px);
    }
  }

  @include mobile {
    align-items: start;
    flex-direction: column;
    gap: 16px;
  }
}

.step2-option-card:hover {
  border: 2px solid #cbdbf7;
  background-color: #f3f5f7;
}

.step2-option-card__index {
  font-weight: 600;
  font-size: 12px;
  line-height: 130%;
  text-align: center;
  color: #675def;
  width: 100%;
  border-radius: 50px;
  padding: 6px 8px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  flex: 1;
}

.step2-option-card__logo {
  max-height: 32px;
  object-fit: contain;

  &--is-credit {
    width: 100%;
    max-width: 200px;
  }

  @include mobile {
    object-position: left center;
  }
}

.step2-option-card__title {
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: #000;
  margin-bottom: 0;
  cursor: pointer;
  flex: 1;

  &--is-credit {
    max-width: 150px;
    width: 100%;
  }
}

.step2-option-card__description {
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #58595a;
  max-width: 454px;
  flex: 3;
}


/* ---------------- Tooltip ---------------- */
.switch-tooltip-wrapper {
  position: absolute;
  left: calc(100% + 10px);
  top: 50%;
  transform: translateY(-50%);
}

.switch-tooltip-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a9a9a9;
  cursor: pointer;
}

</style>